module.exports = __webpack_public_path__ + "static/img/atLogo.a6e102a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/atLogo.png
// module id = WgSh
// module chunks = 37